import React from 'react'
import "./FlagBadge.scss"

export default function FlagBadge({ variant = "sm" }) {
  return (
    <a className={`flag-badge--${variant}`} aria-label="Embroidered Canadian Flag" href="https://stephrowe.ca/assets#flagBadge" target="_blank"
      id="flagBadge"
      rel="noopener noreferrer"
      title="Proudly Canadian"
    />
  )
}
